import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=339823e4&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339823e4')) {
      api.createRecord('339823e4', component.options)
    } else {
      api.reload('339823e4', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=339823e4&", function () {
      api.rerender('339823e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/profile/ChangePassword.vue"
export default component.exports